module.exports = __webpack_public_path__ + "img/img_display_7.e6411762.svg";